<style lang="scss" scoped>
@import "$vars";
h3 {
  font-family: $font1;
  color: black
}
main {
  padding: 0 20px
}
dl {
  padding: 0 20px;
  dt {
    margin-top: 10px;
    border-top: 1px dotted #999;
  }
  dd {
    padding: 0 10px;
    margin: 0;
    &::before {
      content: '• '
    }
  }
}
.btn {
  margin: 20px auto;
  display: block;
}
</style>

<template>
  <main v-if="loaded">
    <header class="flex-space_between">
      <h3 v-if="totalImported > 0">Resultados da importação</h3>
      <h3 v-if="totalImported === 0">Erro na importação</h3>
    </header>
    <div class="toast toast-success" v-if="totalImported > 0">
      <big><strong>{{totalImported}}</strong> linhas foram importadas com sucesso</big>
    </div>
    <div class="toast toast-error" v-if="totalFailed > 0">
      <big><strong>{{totalFailed}}</strong> linhas não puderam ser importadas:</big>
      <dl class="list-unstyled">
        <template v-for="(row, $index) in results">
          <dt :key="'row'+$index"><strong>linha {{row.line}}</strong>: </dt>
          <dd v-for="(error, $index) of row.errors" :key="'error'+row.line+$index"><em>{{error.field}}</em>: {{error.error}}</dd>
        </template>
      </dl>
    </div>
    <hr />
    <button @click="$router.replace({name: 'DoctorPatientsImportPreview'})" class="btn btn-blue">Importar outra planilha</button>
  </main>
</template>

<script>
export default {
  props: ['selectedOffice', 'fileId'],
  data () {
    return {
      loaded: false,
      totalImported: 0,
      totalFailed: 0,
      results: []
    }
  },
  computed: {
    getType () {
      return this.$route.params.type
    }
  },
  mounted () {
    this.fn_SHOW_PROGRESS()
    this.$http.get(`/doctor/doctor_office/${this.selectedOffice.id}/${this.getType}/import/${this.fileId}/action_execute`, this.$store.getters.getAuthHeader).then(
      (res) => {
        this.totalImported = res.data.successTotal
        this.totalFailed = res.data.failureTotal
        let arr = []
        let indexes = []
        for (let error of res.data.error) {
          if (indexes.indexOf(error.line) === -1) {
            indexes.push(error.line)
            arr.push({
              line: error.line,
              errors: [
                {
                  field: error.field,
                  error: error.error
                }
              ]
            })
          } else {
            arr[indexes.indexOf(error.line)].errors.push({
              field: error.field,
              error: error.error
            })
          }
        }
        this.fn_HIDE_PROGRESS()
        this.results = arr
      }
    ).catch(
      (res) => {
        if (res === 'Import already processsed') {
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'Arquivo já processado',
            size: 'md',
            active: true,
            callback: function () {
              this.$router.replace({name: 'DoctorPatientsImportPreview'})
            }
          })
        }
      }
    ).finally(
      () => {
        this.fn_HIDE_PROGRESS()
        this.loaded = true
      }
    )
  }
}
</script>
